import axios from 'axios';
import Eos from 'eosjs';

// Store modules
import auth from './auth';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
const AWS = require('aws-sdk')
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;



// initial state
const state = {
    transactionStatus: {},
}

const getters = { 
}

const mutations = {
  setTransactionStatus (state, trx) {
    console.log(trx)
    state.transactionStatus = trx
  },
}

const actions = {
  tokenContractDeploy: function () {
    let wasm
    let abi

    axios
      .get('http://127.0.0.1:3000/grabTokenWasm')
      .then(response => (wasm = response))
      .then(axios.get('http://127.0.0.1:3000/grabTokenAbi')
      .then(response => (abi = response)))
      .then(ScatterJS.scatter.connect('Smartpress').then(connected => {

        // If the user does not have Scatter or it is Locked or Closed this will return false;
        if(!connected) return false;

        const scatter = ScatterJS.scatter;

        // Now we need to get an identity from the user.
        // We're also going to require an account that is connected to the network we're using.
        const requiredFields = { accounts:[network] };
        scatter.getIdentity(requiredFields).then(() => {

            // Always use the accounts you got back from Scatter. Never hardcode them even if you are prompting
            // the user for their account name beforehand. They could still give you a different account.
            const account = scatter.identity.accounts.find(x => x.blockchain === 'eos');

            // You can pass in any additional options you want into the eosjs reference.
            const eosOptions = { expireInSeconds:60 };

            // Get a proxy reference to eosjs which you can use to sign transactions with a user's Scatter.
            const eos = scatter.eos(network, Eos, eosOptions);

            // Never assume the account's permission/authority. Always take it from the returned account.
            const transactionOptions = { authorization:[`${account.name}@${account.authority}`] };

            eos.setcode(account.name, 0, 0, Buffer.from(wasm.data), transactionOptions).then(trx => {
              eos.setabi(account.name, JSON.parse(Buffer.from(abi.data)), transactionOptions).then(trx => {
                  // That's it!
                  console.log(`Transaction ID: ${trx.transaction_id}`);
     
                  setTimeout(function(){
                    eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
                      contract.create(account.name, 1, '110.00', '210.00', '140.00', '100.00', 'cool place', transactionOptions)
                  }).catch(e => {
                      console.log("error", e);
                  })
                  }, 2000)

             
              }).catch(error => {
                  console.error(error);
              });
                console.log(`Transaction ID: ${trx.transaction_id}`);
            }).catch(error => {
                console.error(error);
            });

        }).catch(error => {
            // The user rejected this request, or doesn't have the appropriate requirements.
            console.error(error);
        });
      }))
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




